<button
  type="button"
  class="card"
  [ngClass]="classes"
  [attr.aria-label]="
    student.firstName +
    ' ' +
    student.lastName +
    (hallPass?.status?.state === HallPassStatus.ACTIVE
      ? MESSAGES.ARIA_LABEL_SELECT_STUDENT_ACTIVE_HALL_PASS
      : hallPass?.status?.state === HallPassStatus.OVERDUE
      ? MESSAGES.ARIA_LABEL_SELECT_STUDENT_OVERDUE_HALL_PASS
      : hallPass?.status?.state === HallPassStatus.PENDING_APPROVAL
      ? MESSAGES.ARIA_LABEL_SELECT_STUDENT_REQUESTED_HALL_PASS
      : '')
  "
  [attr.data-analytics]="'tools-myclass-click-student-card'"
  [attr.data-test]="'tools-myclass-click-student-card'"
  (click)="toggle()">
  <div class="card-wrap">
    <div
      *ngIf="hidePicture === false"
      class="card-avatar">
      <div
        *ngIf="student.filename"
        class="profile-picture"
        [mgStudentPicture]="student.filename"></div>
      <mg-avatar
        *ngIf="!student.filename && student.profileImageUrl"
        [src]="student.profileImageUrl">
      </mg-avatar>
      <div
        *ngIf="!student.filename && !student.profileImageUrl"
        class="profile-picture"
        [style.background-image]="'url(/assets/student-id/placeholder-profile-pic.png)'"></div>
    </div>
    <div class="card-name">
      <mg-text
        class="last-name"
        [numberOfLines]="1"
        [variant]="firstNameFirst ? 'body-sm' : 'header-sm'">
        {{ student.lastName }}
      </mg-text>
      <mg-text
        class="first-name"
        [numberOfLines]="1"
        [variant]="firstNameFirst ? 'header-sm' : 'body-sm'">
        {{ student.firstName }}
      </mg-text>
    </div>
    <div class="card-checkbox">
      <mg-form-checkbox [checked]="selected"></mg-form-checkbox>
    </div>

    <mg-btn
      *ngIf="canViewProfile; else idTemplate"
      class="card-student-id"
      size="small"
      variant="icon-secondary"
      icon="mg-role-o"
      iconSet="minga"
      tooltip="Profile"
      id="tools-myclass-click-view-profile"
      [class.no-picture]="hidePicture"
      [attr.aria-label]="MESSAGES.ARIA_LABEL_VIEW_PROFILE"
      (click)="$event.stopPropagation()"
      target="_blank"
      [href]="getProfileRoute(student.personHash)">
    </mg-btn>
    <ng-template #idTemplate>
      <mg-btn
        [attr.aria-label]="'Nagivate to student id'"
        class="card-student-id"
        size="small"
        variant="icon-secondary"
        icon="mg-id-menu-o"
        iconSet="minga"
        [class.no-picture]="hidePicture"
        (click)="$event.stopPropagation()"
        [routerLink]="getStudentIdRoute(student.personHash)">
      </mg-btn>
    </ng-template>
  </div>

  <!-- Bottom Bar -->
  <div class="bottom-bar tw-flex tw-items-center tw-flex-wrap tw-gap-1">
    <!-- Hall Pass Pill -->
    <ng-container
      *ngIf="hallPass && PASS_STATUS_TO_TYPE[hallPass.status.state]"
      [ngTemplateOutlet]="hallPassPillTemplate">
    </ng-container>

    <!-- Checkin Pill -->
    <ng-container
      *ngIf="isCheckInEnabled$ | async | showCheckIns: showCheckIn:student:(pastCheckIns$ | async)"
      [ngTemplateOutlet]="checkinPillTemplate"
      [ngTemplateOutletContext]="{ checkIns: (pastCheckIns$ | async) }">
    </ng-container>

    <!-- Flextime Pill -->
    <ng-container
      *ngIf="upcomingPeriod && showFlexTime"
      [ngTemplateOutlet]="flextimePillTemplate">
    </ng-container>

    <!-- Praise Pill -->
    <ng-container
      *ngIf="
        ((pastPraises$ | async)?.totalCount > 0 || (pastPraiseConsequences$ | async)?.totalCount > 0) && showBehaviors
      "
      [ngTemplateOutlet]="praisePillTemplate">
    </ng-container>

    <!-- Guidance Pill -->
    <ng-container
      *ngIf="((pastGuidances$ | async)?.totalCount > 0 || (pastConsequences$ | async)?.totalCount > 0) && showBehaviors"
      [ngTemplateOutlet]="guidancePillTemplate">
    </ng-container>
  </div>
</button>

<!-- Hall Pass Pill Template -->
<ng-template #hallPassPillTemplate>
  <ng-container
    *ngIf="
      hallPass
        | countdown
          : (recentlyEndedSetting$ | async)
          : (manuallyEndedPassesSetting$ | async)
          : myClassHallPassService.timeTicker$
          : hallPass.type?.manuallyEndPass
        | async as countdown;
      else loaderTemplate
    ">
    <mg-tt-pill
      [attr.aria-label]="'Active Hall Passes'"
      [type]="
        selected && hallPass.status.state === HallPassStatus.ACTIVE
          ? 'selected'
          : PASS_STATUS_TO_TYPE[hallPass.status.state]
      "
      icon="mg-away"
      [text]="
        hallPass.status.state === HallPassStatus.ACTIVE || hallPass.status.state === HallPassStatus.OVERDUE
          ? '' + countdown
          : ''
      "
      [id]="'tools-myclass-click-pill-hp'"
      [attr.aria-label]="
        hallPass.status.state === HallPassStatus.ACTIVE
          ? MESSAGES.ARIA_LABEL_ACTIVE_HALL_PASS_DETAILS
          : hallPass.status.state === HallPassStatus.ENDED
          ? MESSAGES.ARIA_LABEL_ENDED_HALL_PASS_DETAILS
          : hallPass.status.state === HallPassStatus.OVERDUE
          ? MESSAGES.ARIA_LABEL_OVERDUE_HALL_PASS_DETAILS
          : hallPass.status.state === HallPassStatus.PENDING_APPROVAL
          ? MESSAGES.ARIA_LABEL_REQUESTED_HALL_PASS_DETAILS
          : MESSAGES.ARIA_LABEL_HALL_PASS_DETAILS
      "
      [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
      (click)="$event.stopPropagation()"
      [matMenuTriggerFor]="hallpass">
    </mg-tt-pill>

    <ng-container *ngIf="hallPass | hpmCanApprove: authHash:('HALL_PASS_TYPE_MANAGE' | hasPermission)">
      <div
        class="tt-pill"
        matTooltipClass="mg-tooltip"
        [matTooltip]="MESSAGES.TOOLTIP_DENY_PASS"
        [attr.data-analytics]="'tools-myclass-click-pill-deny'"
        [attr.data-test]="'tools-myclass-click-pill-deny'"
        [attr.aria-label]="MESSAGES.ARIA_LABEL_DENY_PASS"
        (click)="$event.stopPropagation(); onHallPassActionClicked('deny', { skipConfirmation: true })">
        <mg-icon
          class="deny"
          iconName="mg-cross">
        </mg-icon>
      </div>
      <div
        class="tt-pill"
        matTooltipClass="mg-tooltip"
        [matTooltip]="MESSAGES.TOOLTIP_APPROVE_PASS"
        [attr.data-analytics]="'tools-myclass-click-pill-approve'"
        [attr.data-test]="'tools-myclass-click-pill-approve'"
        [attr.aria-label]="MESSAGES.ARIA_LABEL_APPROVE_PASS"
        (click)="$event.stopPropagation(); onHallPassActionClicked('approve', { skipConfirmation: true })">
        <mg-icon
          class="approve"
          iconName="mg-checkmark">
        </mg-icon>
      </div>
    </ng-container>
    <mg-btn
      *ngIf="HallPassStatus.ACTIVE === hallPass.status.state || HallPassStatus.OVERDUE === hallPass.status.state"
      class="tw-flex"
      variant="text"
      size="xsmall"
      id="tools-myclass-click-pill-end"
      [attr.aria-label]="MESSAGES.ARIA_LABEL_END_PASS"
      (click)="$event.stopPropagation()"
      (pressed)="onHallPassActionClicked('end', { skipConfirmation: true })">
      End
    </mg-btn>
    <mat-menu
      #hallpass="matMenu"
      yPosition="below"
      xPosition="after"
      [hasBackdrop]="true">
      <ng-template matMenuContent>
        <div
          class="popup-wrap large"
          fxLayout="column"
          fxLayoutGap="4px">
          <mg-text
            variant="label-md-secondary"
            element="p"
            >{{ hallPass.status.state }} Hall Pass</mg-text
          >
          <mg-text
            variant="label-md"
            element="p">
            {{ hallPass.type?.name }}
          </mg-text>

          <ng-container *ngIf="hallPass.status.state === HallPassStatus.ENDED; else timerTemplate">
            <mg-text
              variant="label-md"
              element="p">
              {{ hallPass.status.end | date: 'hh:mm a' }}
            </mg-text>
          </ng-container>
          <ng-template #timerTemplate>
            <ng-container *ngIf="countdown; else loaderTemplate">
              <div
                fxLayout="row"
                fxLayoutAlign="start center"
                fxLayoutGap="2px">
                <mg-icon
                  *ngIf="showIcon() && hallPass.status.state === HallPassStatus.ACTIVE"
                  class="auto-end-icon"
                  iconName="mg-auto-end">
                </mg-icon>
                <mg-text
                  *ngIf="countdown !== 'DISABLED'"
                  variant="label-md"
                  element="p">
                  {{ countdown }}
                </mg-text>
              </div>
            </ng-container>
          </ng-template>

          <div class="tw-flex tw-justify-center tw-items-center">
            <mg-btn
              *ngIf="
                HallPassStatus.ACTIVE === hallPass.status.state || HallPassStatus.OVERDUE === hallPass.status.state
              "
              variant="text"
              id="tools-myclass-click-end"
              [attr.aria-label]="MESSAGES.ARIA_LABEL_END_PASS"
              (pressed)="onHallPassActionClicked('end')">
              End
            </mg-btn>
            <ng-container *ngIf="hallPass | hpmCanApprove: authHash:('HALL_PASS_TYPE_MANAGE' | hasPermission)">
              <mg-btn
                variant="text"
                id="tools-myclass-click-deny"
                [attr.aria-label]="MESSAGES.ARIA_LABEL_DENY_PASS"
                (pressed)="onHallPassActionClicked('deny')">
                Deny
              </mg-btn>
              <mg-btn
                variant="text"
                id="tools-myclass-click-approve"
                [attr.aria-label]="MESSAGES.ARIA_LABEL_APPROVE_PASS"
                (pressed)="onHallPassActionClicked('approve')">
                Approve
              </mg-btn>
            </ng-container>
          </div>
        </div>
      </ng-template>
    </mat-menu>
  </ng-container>
</ng-template>

<!-- Praise Pill Template -->
<ng-template #praisePillTemplate>
  <mg-tt-pill
    type="success"
    [text]="(pastPraises$ | async)?.totalCount + (pastPraiseConsequences$ | async)?.totalCount"
    [attr.aria-label]="
      MESSAGES.ARIA_LABEL_PRAISE_ASSIGNED +
      ((pastPraises$ | async)?.totalCount + (pastPraiseConsequences$ | async)?.totalCount)
    "
    [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
    [matMenuTriggerFor]="pastPraises"
    (click)="$event.stopPropagation()">
  </mg-tt-pill>
  <mat-menu
    #pastPraises="matMenu"
    yPosition="below"
    xPosition="after"
    [hasBackdrop]="true">
    <ng-template matMenuContent>
      <div
        class="popup-wrap"
        fxLayout="column"
        fxLayoutGap="4px">
        <div *ngIf="(pastPraises$ | async)?.totalCount > 0">
          <mg-text
            variant="label-md-secondary"
            element="p"
            >Praises</mg-text
          >
          <mg-text
            *ngFor="let praise of (pastPraises$ | async)?.items"
            variant="label-md"
            element="p">
            {{ praise.count }} {{ praise.label }}
          </mg-text>
        </div>
        <div *ngIf="(pastPraiseConsequences$ | async)?.totalCount > 0">
          <mg-text
            variant="label-md-secondary"
            element="p"
            >Consequences</mg-text
          >
          <mg-text
            *ngFor="let consequence of (pastPraiseConsequences$ | async)?.items"
            variant="label-md"
            element="p">
            {{ consequence.count }} {{ consequence.label }}
          </mg-text>
        </div>
      </div>
    </ng-template>
  </mat-menu>
</ng-template>

<!-- Guidance Pill Template -->
<ng-template #guidancePillTemplate>
  <mg-tt-pill
    type="error"
    [text]="(pastGuidances$ | async)?.totalCount + (pastConsequences$ | async)?.totalCount"
    [attr.aria-label]="
      MESSAGES.ARIA_LABEL_GUIDANCE_ASSIGNED +
      ((pastGuidances$ | async)?.totalCount + (pastConsequences$ | async)?.totalCount)
    "
    [id]="'tools-myclass-click-pill-guid'"
    [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
    (click)="$event.stopPropagation()"
    [matMenuTriggerFor]="pastGuidances">
  </mg-tt-pill>
  <mat-menu
    #pastGuidances="matMenu"
    yPosition="below"
    xPosition="after"
    [hasBackdrop]="true">
    <ng-template matMenuContent>
      <div
        class="popup-wrap"
        fxLayout="column"
        fxLayoutGap="4px">
        <div *ngIf="(pastGuidances$ | async)?.totalCount > 0">
          <mg-text
            variant="label-md-secondary"
            element="p"
            >Guidances</mg-text
          >
          <mg-text
            *ngFor="let guidance of (pastGuidances$ | async)?.items; let i = index"
            variant="label-md"
            element="p">
            {{ guidance.count }} {{ guidance.label }}
          </mg-text>
        </div>
        <div *ngIf="(pastConsequences$ | async)?.totalCount > 0">
          <mg-text
            variant="label-md-secondary"
            element="p"
            >Consequences</mg-text
          >
          <mg-text
            *ngFor="let consequence of (pastConsequences$ | async)?.items; let i = index"
            variant="label-md"
            element="p">
            {{ consequence.count }} {{ consequence.label }}
          </mg-text>
        </div>
      </div>
    </ng-template>
  </mat-menu>
</ng-template>

<!-- Checkin Pill Template -->
<ng-template
  #checkinPillTemplate
  let-checkIns="checkIns">
  <mg-tt-pill
    [attr.aria-label]="
      checkIns?.length === 0 ? MESSAGES.ARIA_LABEL_NOT_CHECKED_IN_DETAILS : MESSAGES.ARIA_LABEL_CHECKED_IN_DETAILS
    "
    [type]="checkIns?.length === 0 ? 'muted' : 'success'"
    [icon]="checkIns?.length === 0 ? 'mg-not-checked-in' : 'mg-checkin-menu'"
    [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
    (click)="$event.stopPropagation()"
    [matMenuTriggerFor]="checkin">
    <mat-menu
      #checkin="matMenu"
      yPosition="below"
      xPosition="after"
      [hasBackdrop]="true">
      <ng-template matMenuContent>
        <div class="popup-wrap large tw-flex tw-flex-column tw-gap-2">
          <ng-container *ngIf="checkIns?.length > 0; else noCheckInsTemplate">
            <div
              *ngFor="let checkIn of checkIns"
              class="tw-flex tw-flex-column tw-gap-1">
              <mg-text
                variant="label-md-secondary"
                element="p">
                {{ checkIn.title }}
              </mg-text>
              <mg-text
                variant="label-md"
                element="p">
                {{ checkIn.name }}
              </mg-text>
              <mg-text
                variant="label-md"
                element="p">
                Time: {{ checkIn.checkedInAt | date: 'h:mm a' }}
              </mg-text>
            </div>
          </ng-container>
          <ng-template #noCheckInsTemplate>
            <mg-text
              variant="label-md-secondary"
              element="p">
              Not checked in
            </mg-text>
          </ng-template>
        </div>
      </ng-template>
    </mat-menu>
  </mg-tt-pill>
</ng-template>

<!-- Flextime Pill Template -->
<ng-template #flextimePillTemplate>
  <mg-tt-pill
    [attr.aria-label]="
      upcomingFlexActivity
        ? MESSAGES.ARIA_LABEL_FLEX_REGISTERED_DETAILS
        : MESSAGES.ARIA_LABEL_FLEX_NOT_REGISTERED_DETAILS
    "
    [type]="upcomingFlexActivity ? 'success' : 'muted'"
    [icon]="'mg-flextime-menu'"
    [size]="(mediaService.isMobileView$ | async) ? 'medium' : 'small'"
    (click)="$event.stopPropagation()"
    [matMenuTriggerFor]="flextime">
    <mat-menu
      #flextime="matMenu"
      yPosition="below"
      xPosition="after"
      [hasBackdrop]="true">
      <ng-template matMenuContent>
        <div class="popup-wrap extra-large tw-flex tw-flex-column">
          <mg-text
            variant="label-md-secondary"
            element="p">
            {{ upcomingFlexActivity ? 'Upcoming activity' : 'Not registered to upcoming activity' }}
          </mg-text>
          <mg-text
            variant="label-md"
            element="p">
            Date: {{ upcomingPeriod.date | date: 'MMM d' }}
          </mg-text>
          <mg-text
            variant="label-md"
            element="p">
            Time: {{ upcomingPeriod | formatTimeRange }}
          </mg-text>
          <mg-text
            variant="label-md"
            element="p">
            Period: {{ upcomingPeriod.title }}
          </mg-text>
          <ng-container *ngIf="upcomingFlexActivity">
            <mg-text
              variant="label-md"
              element="p">
              Activity: {{ upcomingFlexActivity.flexTimeActivity?.name }}
            </mg-text>
            <mg-text
              variant="label-md"
              element="p">
              Teacher: {{ upcomingFlexActivity.flexTimeActivity?.createdByPerson?.name }}
            </mg-text>
            <mg-text
              variant="label-md"
              element="p">
              Location: {{ upcomingFlexActivity.flexTimeActivity?.location }}
            </mg-text>
          </ng-container>
          <div
            *ngIf="!upcomingFlexActivity"
            class="tw-flex tw-justify-between tw-items-center">
            <mg-btn
              variant="text"
              size="small"
              (pressed)="flexActivityAction('assign')">
              Assign
            </mg-btn>
            <mg-btn
              variant="text"
              size="small"
              (pressed)="flexActivityAction('register')">
              Register
            </mg-btn>
          </div>
        </div>
      </ng-template>
    </mat-menu>
  </mg-tt-pill>
</ng-template>

<!-- Loader Template -->
<ng-template #loaderTemplate>
  <div class="inline-spinner">
    <mg-spinner
      [diameter]="16"
      [thickness]="2">
    </mg-spinner>
  </div>
</ng-template>
